import React from 'react';
import { Link, useLocation } from 'react-router-dom';

const ErrorPage = ({ statusCode }) => {
  const location = useLocation();
  const notFound = statusCode === 404;

  return (
    <div className="h-full overflow-y-auto px-8 py-16">
      <div className="max-w-xl">
        <h1 className="text-title text-ink">{notFound ? 'Page not found' : 'Something went wrong'}</h1>
        <p className="mt-3 text-body text-graphite">
          {notFound ? (
            <>
              There is no page at <span className="font-mono text-ink break-all">{location.pathname}</span>. Check the address, or start from the dashboard.
            </>
          ) : 'The page could not be loaded. Try again, or start from the dashboard.'}
        </p>
        <div className="mt-6 flex gap-2">
          <Link to="/dashboard" className="inline-flex items-center h-8 px-3 rounded-control bg-signal text-signal-ink text-body font-semibold hover:bg-signal/90">
            Go to dashboard
          </Link>
          <Link to="/vulnerabilities" className="inline-flex items-center h-8 px-3 rounded-control border border-rule bg-sheet text-ink text-body hover:bg-hover">
            Browse vulnerabilities
          </Link>
        </div>
      </div>
    </div>
  );
};

export default ErrorPage;
